import { User, authDao } from '../dao/auth-dao'
import { browserUtil, clientGuidService, tokenService } from '@grndhouse/react-common'

export const authService = {
  login: async (params: { email: string; password: string; redirectUrl?: string }): Promise<void> => {
    const { email, password, redirectUrl: initRedirectUrl } = params
    const clientGuid = clientGuidService.getOrCreate()
    const { accessToken, refreshToken, redirectUrl: apiRedirectUrl } = await authDao.login({ clientGuid, email, password })
    const redirectUrl = initRedirectUrl ?? apiRedirectUrl
    authService._storeTokenAndRedirect({ accessToken, refreshToken, redirectUrl })
  },
  registerNewUser: async (params: { email: string }): Promise<void> => {
    await authDao.register(params)
  },
  registerVerifyEmail: async (params: { email: string; code: string }): Promise<{ redirectUrl: string }> => {
    const { email, code } = params
    const clientGuid = clientGuidService.getOrCreate()
    const { accessToken, refreshToken, redirectUrl } = await authDao.registerVerifyEmail({ email, code, clientGuid })
    tokenService.store({ accessToken, refreshToken })
    return { redirectUrl }
  },
  setInitialPassword: async (data: { password: string }): Promise<void> => {
    await authDao.setInitialPassword(data)
  },
  getUsers: (): Promise<User[]> => {
    return authDao.getUsers()
  },
  partialUpdateUser: (params: { user: User; data: Partial<User> }): Promise<User> => {
    const { user, data } = params
    return authDao.partialUpdateUser({ userId: user.id, data })
  },
  requestResetPassword: (params: { email: string }): Promise<void> => {
    return authDao.requestResetPassword(params)
  },
  resetPassword: async (params: { email: string; code: string; password: string }): Promise<{ redirectUrl: string }> => {
    const { email, code, password } = params
    const clientGuid = clientGuidService.getOrCreate()
    const { accessToken, refreshToken, redirectUrl } = await authDao.resetPassword({ email, code, clientGuid, password })
    tokenService.store({ accessToken, refreshToken })
    return { redirectUrl }
  },
  fulfillImportWelcome: async (params: { email: string; code: string; password: string }): Promise<{ redirectUrl: string }> => {
    const { email, code, password } = params
    const clientGuid = clientGuidService.getOrCreate()
    const { accessToken, refreshToken, redirectUrl } = await authDao.fulfillImportWelcome({ email, code, clientGuid, password })
    tokenService.store({ accessToken, refreshToken })
    return { redirectUrl }
  },
  updateUserNameAndLegals: (params: { name: string; acceptAllLegals?: boolean }): Promise<void> => {
    return authDao.updateUserNameAndLegals(params)
  },
  verifyEmail: (params: { code: string }): Promise<void> => {
    return authDao.verifyEmail(params)
  },
  requestEmailVerification: (user: User): Promise<void> => {
    const clientGuid = clientGuidService.getOrCreate()
    return authDao.requestEmailVerification({ userId: user.id, clientGuid })
  },
  _storeTokenAndRedirect: (params: { accessToken: string; refreshToken: string; redirectUrl: string }): void => {
    const { accessToken, refreshToken, redirectUrl } = params
    tokenService.store({ accessToken, refreshToken })
    browserUtil.redirect(redirectUrl)
  },
  agreeToLatestLegalAgreements: async (): Promise<void> => {
    await authDao.agreeToLatestLegalAgreements()
  },
  getMe: async (): Promise<User> => {
    return authDao.getUserMe()
  },
  signInWithApple: async (params: { redirectUrl: string }): Promise<void> => {
    const { url } = await authDao.signInWithApple(params)
    window.location.href = url
  },
}
